import Cookie from 'js-cookie';
import { Modal } from 'react-bootstrap';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function AgeGate(){
    const { t } = useTranslation();
    const [ showAgeGate, setShowAgeGate ] = useState(Cookie.get('ofage')!=='true');

    const handleOfAge = () => {
        Cookie.set('ofage', true);
        setShowAgeGate(false);
    }
    const handleNotOfAge = () => {
        document.location.href = 'https://snackworks.ca';
    }

    return (
        <Modal
            show={showAgeGate} 
            backdrop="static"
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered>
            <Modal.Body className="text-center">
                <h2>{t('agegate.title')}</h2>
                <p>{t('agegate.body')}</p>
                <div>
                    <button onClick={handleOfAge} className="m-2">{t('agegate.confirm')}</button>
                    <button onClick={handleNotOfAge} className="m-2 white">{t('agegate.exit')}</button>
                </div>
            </Modal.Body>
        </Modal>
    )
}
